export let teamsChatPaneHeaderText = "WGzcVb";
export default {teamsChatPaneHeaderText};